import React from "react";
import { Scale, Clock, DollarSign, Users, Award, HeadphonesIcon } from "lucide-react";

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <Scale />,
      title: "Expert Legal Team",
      description: "Our team includes experienced trademark attorneys and USPTO-registered agents who have successfully handled thousands of trademark applications across diverse industries.",
    },
    {
      icon: <Award />,
      title: "98% Success Rate",
      description: "With a 98% approval rate, our expertise and thorough preparation significantly increase your chances of successful trademark registration.",
    },
    {
      icon: <Clock />,
      title: "Fast 24-48hr Processing",
      description: "We prioritize your trademark application with expedited processing. Most applications are reviewed and filed within 24-48 hours of receiving your information.",
    },
  ];

  return (
    <section id="why-choose-us" className="why-choose-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why Choose trademarkIcontext</h2>
          <p className="section-subtitle">
            The Advantages of Working with Trademark Specialists
          </p>
        </div>

        <div className="why-choose-content">
          <div className="why-choose-image">
            <img 
              src="https://images.pexels.com/photos/5257005/pexels-photo-5257005.jpeg" 
              alt="Professional team collaboration" 
              loading="lazy"
            />
          </div>

          <div className="reasons-grid">
            {reasons.map((reason, index) => (
              <div key={index} className="reason-card">
                <div className="reason-icon">{reason.icon}</div>
                <div className="reason-content">
                  <h4 className="reason-title">{reason.title}</h4>
                  <p className="reason-description">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
